import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import "echarts/lib/component/title";
  import { ref, nextTick } from "vue";
  import VCharts from "vue-echarts";
  // import { useAppStore } from '@/store';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    autoresize: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
  },
  setup(__props, { expose: __expose }) {

  
  // const appStore = useAppStore();
  // const theme = computed(() => {
  //   if (appStore.theme === 'dark') return 'dark';
  //   return '';
  // });
  const renderChart = ref(false);
  const chartRef = ref<any>(null);
  
  // wait container expand
  nextTick(() => {
    renderChart.value = true;
  });
  
  // 暴露图表实例
  __expose({
    chart: chartRef,
    getChartInstance: () => {
      // vue-echarts 的实例通过多种方式尝试获取
      if (!chartRef.value) {
        return null;
      }
      
      // 方式1: 通过 getEchartsInstance 方法（vue-echarts 6.x）
      if (typeof chartRef.value.getEchartsInstance === 'function') {
        return chartRef.value.getEchartsInstance();
      }
      
      // 方式2: 通过 chart 属性
      if (chartRef.value.chart) {
        return chartRef.value.chart;
      }
      
      // 方式3: 直接返回（vue-echarts 5.x 或更早版本）
      if (typeof chartRef.value.dispatchAction === 'function') {
        return chartRef.value;
      }
      
      // 方式4: 通过 $el 获取 DOM 上的实例
      if (chartRef.value.$el) {
        const dom = chartRef.value.$el.querySelector('div');
        if (dom && (dom as any).__echarts_instance__) {
          return (dom as any).__echarts_instance__;
        }
      }
      
      return null;
    }
  });

return (_ctx: any,_cache: any) => {
  return (renderChart.value)
    ? (_openBlock(), _createBlock(_unref(VCharts), {
        key: 0,
        ref_key: "chartRef",
        ref: chartRef,
        option: __props.options,
        autoresize: __props.autoresize,
        style: _normalizeStyle({ width: __props.width, height: __props.height }),
        "update-options": { notMerge: true }
      }, null, 8, ["option", "autoresize", "style"]))
    : _createCommentVNode("", true)
}
}

})